import { useEffect, useState } from 'react';

export default function useSize(target) {
  const [size, setSize] = useState(null);

  const resizeObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      setSize(entry.contentRect);
    });
  });

  useEffect(() => {
    if (target.current) {
      setSize(target.current.getBoundingClientRect());
      resizeObserver.observe(target.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [target.current]);

  return size;
}
